type Props = {
  className?: string
  width?: number
  height?: number
}

export const DoubleHalfCircleIcon = ({ className, width = 43, height = 43 }: Props) => {
  return (
    <span className={className}>
      <svg width={width} height={height} viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_7208_1294"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="43"
          height="43"
        >
          <rect x="0.666504" y="0.499756" width="41.6667" height="41.6667" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_7208_1294)">
          <mask
            id="mask1_7208_1294"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="22"
            height="42"
          >
            <path
              d="M0.66683 1.34204C11.9426 1.34204 21.0835 10.4829 21.0835 21.7587V21.7587C21.0835 33.0345 11.9426 42.1754 0.666828 42.1754V42.1754L0.66683 1.34204V1.34204Z"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask1_7208_1294)">
            <rect
              width="41.6667"
              height="24.1667"
              transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 22.3335 48.8333)"
              fill="#D9D9D9"
            />
            <g filter="url(#filter0_f_7208_1294)">
              <g clipPath="url(#paint0_angular_7208_1294_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0265165 -0.0265165 0.0265165 0.0265165 6.92333 27.1435)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="5.45019" cy="28.6167" r="31.6667" transform="rotate(45 5.45019 28.6167)" />
            </g>
            <g filter="url(#filter1_f_7208_1294)">
              <circle cx="4.8335" cy="14.6665" r="12.5" fill="url(#paint1_radial_7208_1294)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask2_7208_1294"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="21"
            y="1"
            width="21"
            height="42"
          >
            <path
              d="M21.0833 1.34204C32.3591 1.34204 41.5 10.4829 41.5 21.7587V21.7587C41.5 33.0345 32.3591 42.1754 21.0833 42.1754V42.1754L21.0833 1.34204V1.34204Z"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask2_7208_1294)">
            <rect
              width="41.6667"
              height="24.1667"
              transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 43.1665 42.9998)"
              fill="#D9D9D9"
            />
            <g filter="url(#filter2_f_7208_1294)">
              <g clipPath="url(#paint2_angular_7208_1294_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0265165 -0.0265165 0.0265165 0.0265165 27.7568 13.81)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(200, 228, 254, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="26.2837" cy="15.2832" r="31.6667" transform="rotate(45 26.2837 15.2832)" />
            </g>
            <g filter="url(#filter3_f_7208_1294)">
              <circle cx="25.6665" cy="8.83325" r="12.5" fill="url(#paint3_radial_7208_1294)" fillOpacity="0.4" />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_7208_1294"
            x="-31.5496"
            y="-8.38338"
            width="73.9997"
            height="74.0002"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1294" />
          </filter>
          <clipPath id="paint0_angular_7208_1294_clip_path">
            <circle cx="5.45019" cy="28.6167" r="31.6667" transform="rotate(45 5.45019 28.6167)" />
          </clipPath>
          <filter
            id="filter1_f_7208_1294"
            x="-12.9998"
            y="-3.16683"
            width="35.6667"
            height="35.6667"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1294" />
          </filter>
          <filter
            id="filter2_f_7208_1294"
            x="-10.7161"
            y="-21.7169"
            width="73.9997"
            height="74.0002"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1294" />
          </filter>
          <clipPath id="paint2_angular_7208_1294_clip_path">
            <circle cx="26.2837" cy="15.2832" r="31.6667" transform="rotate(45 26.2837 15.2832)" />
          </clipPath>
          <filter
            id="filter3_f_7208_1294"
            x="7.83317"
            y="-9.00008"
            width="35.6667"
            height="35.6667"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2.66667" result="effect1_foregroundBlur_7208_1294" />
          </filter>
          <radialGradient
            id="paint1_radial_7208_1294"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(15.3598 27.1665) rotate(-110.519) scale(30.0303)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_7208_1294"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(36.1928 21.3333) rotate(-110.519) scale(30.0303)"
          >
            <stop offset="1" stopColor="#E2FFF5" />
          </radialGradient>
        </defs>
      </svg>
    </span>
  )
}
